module.exports = __webpack_public_path__ + "img/card1_min.9741070f.png";